module.exports = {
  INIT: 'init',
  COMPLETED: 'completed',
  VALIDATED: 'validated',
  CHECKED: 'checked',
  INVOICED: 'invoiced',
  CANCELLED: 'cancelled',
  REFUSED: 'refused',
};
